export const protocoloCero = [
  {
    "id_item":"Acuerdo que Contiene el Protocolo Cero",
    "img_url":"../../images/acuerdo.jpg",
    "titulos_array":[
       {
            "link_item_nombre":"Ver más",
            "link_item_url":"../../contenido/transparencia/protocolocero/Acuerdo.pdf" 
       }
      
    ]
 },
 {
  "id_item":"Pronunciamiento Protocolo Cero",
  "img_url":"../../images/Pronunciamiento.jpg",
  "titulos_array":[
     {
          "link_item_nombre":"Secretaria de Salud SESA",
          "link_item_url":"../../contenido/transparencia/protocolocero/PRONUNCIAMIENTO SESA.pdf" 
     },
     {
      "link_item_nombre":"Servicios de Salud SSH",
      "link_item_url":"../../contenido/transparencia/protocolocero/PRONUNCIAMIENTO SSH.pdf" 
    }
    
  ]
},
{
  "id_item":"Convocatoria",
  "img_url":"../../images/Convocatoria.jpg",
  "titulos_array":[
     {
          "link_item_nombre":"Secretaria de Salud SESA",
          "link_item_url":"../../contenido/transparencia/protocolocero/convocatoria SESA.pdf" 
     },
     {
      "link_item_nombre":"Servicios de Salud SSH",
      "link_item_url":"../../contenido/transparencia/protocolocero/cnvocatoria SSH.pdf" 
    }
    
  ]
},
];